import React, { useState } from 'react';
import style from './baseDeCalculoAccordion.module.scss';

import { Button, Modal } from 'react-dsgov';
import CustomConfirmer from 'components/customConfirmer/customConfirmer';
import { BrButton } from '@govbr-ds/react-components';

interface IBaseDeCalculoAccordionProps {
  children: React.ReactNode;
  title: string;
  deleteFunction: () => Promise<void>;
  editFunction: () => void;
  isNCM?: boolean;
  isEditable?: boolean;
}

const BaseDeCalculoAccordion = ({
  children,
  title,
  deleteFunction,
  editFunction,
  isNCM = false,
  isEditable = true,
}: IBaseDeCalculoAccordionProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [isModalOpened, setIsModalOpened] = useState(false);

  return (
    <>
      <Modal title='Excluir' useScrim modalOpened={isModalOpened}>
        <Modal.Body>
          Deseja mesmo deletar {isNCM ? 'o' : 'a base de cálculo'} {title} selecionado(a)?
        </Modal.Body>
        <Modal.Footer justify-content='end'>
          <Button secondary small m={2} onClick={() => setIsModalOpened(false)}>
            Cancelar
          </Button>
          <CustomConfirmer asyncCall={() => deleteFunction()}>Confirmar</CustomConfirmer>
        </Modal.Footer>
      </Modal>
      <div
        className={style.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={style.title}>{title}</div>
        </div>
        <div className={style.rightContainer}>
          {isEditable && (
            <>
              <BrButton
                data-testid='editar-base-calculo'
                circle
                size='small'
                icon='fas fa-edit fa-sm'
                onClick={() => editFunction()}
              />
              <BrButton
                data-testid='deletar-base-calculo'
                circle
                size='small'
                icon='fas fa-trash fa-sm'
                onClick={() => setIsModalOpened(true)}
              />
            </>
          )}
        </div>
      </div>
      {isAccordionOpen && <div className={style.accordionContent}>{children}</div>}
    </>
  );
};

export default BaseDeCalculoAccordion;
